import { FC, useState } from 'react';

import { useLogout } from '@/global-hooks/use-logout';
import { Modal, TextButton } from '@/shared/design-system';

export const LogoutButton: FC<{ className?: string }> = ({ className }) => {
  const [open, setOpen] = useState(false);
  const { logout, isLoggingOut } = useLogout();

  return (
    <>
      <TextButton color="neutral" className={className} onClick={() => setOpen(true)}>
        Log out
      </TextButton>
      <Modal
        open={open}
        onOpenChange={setOpen}
        variant="center"
        maxWidth={400}
        title="Your answers are saved. Log out?"
        primaryAction={{ label: 'Log out', onClick: () => logout(), disabled: isLoggingOut }}
        secondaryAction={{
          label: 'Cancel',
          variant: 'outline',
          color: 'secondary',
          onClick: () => setOpen(false),
        }}
      >
        {null}
      </Modal>
    </>
  );
};
